import React from 'react';

// import { NavLink as RouterLink } from 'react-router';
import styled from '@emotion/styled';

interface ChangePasswordWrapperProps {
  children: React.ReactNode;
  formHeaderTitle?: string;
  formHeaderDescription?: string | React.ReactNode;
}

const ChangePasswordWrapper: React.FC<ChangePasswordWrapperProps> = ({
  children,
  formHeaderTitle,
  formHeaderDescription,
}) => {
  return (
    <Container>
      <FormSectionHeader>
        <FormSectionHeaderTitle>{formHeaderTitle}</FormSectionHeaderTitle>
        <FormSectionHeaderDescription>
          {formHeaderDescription}
        </FormSectionHeaderDescription>
      </FormSectionHeader>
      <HorizontalDivider />
      {children}
      {/* <FormFooter>
        Don’t have an account? <Link to={'/account/signup'}>Sign up</Link>
      </FormFooter> */}
    </Container>
  );
};

export default ChangePasswordWrapper;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 400px;
  margin: 0 auto;

  @media (max-width: 480px) {
    width: 100%;
    max-width: 400px;
  }
`;

const HorizontalDivider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${({ theme }) => theme.palette.borderColor};
`;

const FormSectionHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  @media (max-width: 480px) {
    width: 100%;
  }
`;

const FormSectionHeaderTitle = styled.div`
  display: flex;
  text-align: left;
  font-size: 20px;
  line-height: 27.32px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.logirateBlack};
`;

const FormSectionHeaderDescription = styled.div`
  display: flex;
  text-align: left;
  font-size: 14px;
  line-height: 19px;
  font-weight: 500;
  color: ${({ theme }) => theme.palette.formDescriptionText};
`;

// const FormFooter = styled.div`
//   margin: 0 72px;
//   font-size: 12px;
//   text-align: center;
//   color: ${({ theme }) => theme.palette.formFooterText};

//   @media (max-width: 480px) {
//     gap: 0px;
//   }
// `;

// const Link = styled(RouterLink)`
//   text-decoration: none;
//   color: ${({ theme }) => theme.palette.logiratePrimary};
//   font-weight: 600;
// `;
